import { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation, Link } from 'react-router-dom';
import { Formik, Field, Form, useFormikContext } from 'formik';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Button, Grid, Label, Message, Icon, Checkbox, Divider } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import '../../components/jsonEditor/jsonEditor.css';

import { HeaderAndPage } from '../../common/components';
import { AuthStdFooter } from "../../utils/auth-std-footer";

import storyImporter from '../../assets/storyImporter_512x512.svg';

import {
  addStoryBookItem,
  CustomDropdown,
  fetchAllBooks,
  fetchFullBook,
  moveAllFiles,
  uploadHtmlToS3,
  uploadFileToS3,
  uploadPdfFileToS3,
  processUploadedPdf,
  fetchUserAndBookStatistics,
  selectBookListOptions,
  clearStory
} from '../../slices/storyEditorSlice';


import PdfViewer from '../../components/aaiPdfViewer';
import CustomToolbar from '../../components/customToolbar';
import ProcessingStatusHint from '../../components/ProcessingStatusHint';
import UtilityModal from '../../utils/modal-helper';
import { fetchSignedUrlByType } from '../../utils/fetchSignedUrlByFolderV2';

import storyInjestion from '../../assets/story-editor-injestion.jpg';

const StoryEditor = ({ titleText }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const userProfile = useSelector(state => state.user.profile);
  const bookListOptions = useSelector(selectBookListOptions);
  const [modalOpen, setModalOpen] = useState(false);

  const [artListDropdownOpen, setArtListDropdownOpen] = useState(false);
  const storySelectedObj = useRef({});
  const [formData, setFormData] = useState('<p>Initial data</p>')

  let thumbnailSignedUrl = useRef({});
  let contentSignedUrl = useRef({});
  let formContent = useRef("");
  let activeElapsedTime = useRef(0);


  const initialValues = {
    title: '',
    author: '',
    startDate: new Date(),
    updatedDate: new Date(),
    category: ["1"],
    storyFileName: null,
    thumbnail: null,
    excerpt: '',
    content: '',
    contentUrl: "./shadowResponse.pdf",
    enabled: true,
    selectedStory: '',
    activeStoryObj: {},
    pdfFile: null
  };

  const refreshFetch = useCallback(() => {
    if (!userProfile?.data?.userId) {
      console.log('User profile not loaded yet, skipping fetch');
      return;
    }

    dispatch(fetchAllBooks({ userId: userProfile.data.userId, reqCategories: "" }))
      .unwrap()
      .then(data => {
        console.log('fetchAllBook in refreshFetch');
      })
      .catch(error => {
        // handle error here
      });
  }, [dispatch, userProfile?.data?.userId]);

  const getFullBook = (bookUuid) => {
    if (!userProfile?.data?.userId) {
      console.log('User profile not loaded yet, skipping getFullBook');
      return;
    }

    dispatch(fetchFullBook({ userId: userProfile.data.userId, bookUuid: bookUuid }))
      .unwrap()
      .then(data => {
        console.log('fetchFullBook in refreshFetch', data);
      })
      .catch(error => {
        // handle error here
      });
  };

  useEffect(() => {
    dispatch(clearStory());
  }, [dispatch]);

  useEffect(() => {
    const debouncedFetch = _.debounce(refreshFetch, 500);

    // Call the debounced function
    debouncedFetch();

    // Cleanup the debounce on unmount
    return () => {
      debouncedFetch.cancel();
    };
  }, [refreshFetch]); // Only re-debounce if refreshFetch changes


  useEffect(() => {
    console.log('location', location)
  }, [location])
  const UpdateFieldValue = ({ formData }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
      // Example of setting the field value after initialization
      setFieldValue('content', formData);
    }, [setFieldValue, formData]);

    return null;
  };

  const FieldChangeHandler = ({ initialValues, storySelectedObj, bookListOptions }) => {
    const formik = useFormikContext();
    const dispatch = useDispatch();
    const previousValuesRef = useRef(initialValues);

    useEffect(() => {
      const handleFieldChange = () => {
        const currentValues = formik.values;
        const previousValues = previousValuesRef.current;
        const changedFields = Object.keys(currentValues).reduce((acc, key) => {
          if (currentValues[key] !== previousValues[key]) {
            acc[key] = { previous: previousValues[key], current: currentValues[key] };
          }
          return acc;
        }, {});

        if (Object.keys(changedFields).length > 0) {
          Object.keys(changedFields).forEach((field) => {
            const { previous, current } = changedFields[field];

            switch (field) {
              case 'title':
                // console.log(`Title changed from "${previous}" to "${current}"`);
                break;
              case 'enabled':
                // console.log(`Enabled changed from "${previous}" to "${current}"`);
                break;
              case 'thumbnail':
                // console.log("Thumbnail changed from ", previous, "to", current);
                break;
              case 'selectedStory':

                let prevStory = storySelectedObj.current?.data?.uuid || "";
                let foundStoryOption = _.find(bookListOptions, (x) => x.value === current);

                formik.setFieldValue('activeStoryObj', foundStoryOption);
                storySelectedObj.current = foundStoryOption;
                console.log(`selectedStory changed from "${previous}" to "${current}"`);

                if (storySelectedObj.current && storySelectedObj.current.data && prevStory !== storySelectedObj.current.data.uuid) {
                  dispatch(fetchUserAndBookStatistics(storySelectedObj.current.data.uuid)).unwrap();
                  getFullBook(storySelectedObj.current.data.uuid);
                }
                break;
              default:
                break;
            }
          });
        }

        previousValuesRef.current = currentValues;
      };

      handleFieldChange();
    }, [formik.values, bookListOptions, dispatch, storySelectedObj, formik]);

    return null;
  };

  const handleBookDDOpen = useCallback(() => setArtListDropdownOpen(true), []);
  const handleBookDDClose = useCallback(() => setArtListDropdownOpen(false), []);
  const handleModalClose = useCallback(() => setModalOpen(false), []);
  const handleModalCancel = useCallback(() => setModalOpen(false), []);

  const handleModalSubmit = () => {
    setModalOpen(false);
  };
  const handleClear = (resetForm) => {
    setModalOpen(false);
    // setStoryFileName(null);
    // setThumbnail(null);
    resetForm({
      values: initialValues
    });
  };

  // const callBackElapsedTime = (elapsedTime) => {
  //   activeElapsedTime.current = elapsedTime;
  // };

  const submitForm = async (formValues, processStatistics) => {
    if (!userProfile?.data?.userId) {
      console.log('User profile not loaded, cannot submit form');
      return;
    }

    let saveBookParams = {
      userId: userProfile.data.userId,
      bookUuid: storySelectedObj.current.data.uuid ? storySelectedObj.current.data.uuid : uuidv4(),
      fileName: formValues.pdfFile.name.split('.').slice(0, -1).join('.'),
      thumbnail: formValues.thumbnail.name,
      ...processStatistics
    };
    console.log('submitForm', saveBookParams);
    dispatch(addStoryBookItem(saveBookParams));
    dispatch(clearStory());
  };

  // Callback function for toolbar file URL selection
  const handleFileURlSelection = (url) => {
    console.log('fileURlCallback: url', url);
    // This will be handled by the CustomToolbar component directly through Formik context
  };

  const onSubmit = async (values, { resetForm }) => {
    if (!userProfile?.data?.userId) {
      console.log('User profile not loaded, cannot submit');
      return;
    }

    const { storyFileName, thumbnail, title, activeStoryObj, pdfFile } = values;
    if (_.isEmpty(storyFileName) ||
      _.isEmpty(thumbnail) ||
      _.isEmpty(title) ||
      _.isEmpty(activeStoryObj)) {
      console.log('Missing Submit Required fields'.values)
      return;
    }

    let bookTypeName = 'book-process-items';
    thumbnailSignedUrl.current.signedUrl = await fetchSignedUrlByType({
      requestType: 'BOOK_ELEMENTS_IMAGE',
      userId: userProfile.data.userId,
      bookUuid: storySelectedObj.current.data.uuid,
      fileName: thumbnail.name
    });
    let selectedPdfFileName = await uploadPdfFileToS3(pdfFile, userProfile.data.userId, activeStoryObj.data.uuid);

    console.log('upload source to S3 ', selectedPdfFileName)
    let uploadData = await processUploadedPdf(selectedPdfFileName, userProfile.data.userId, activeStoryObj.data.uuid);

    console.log('uploadBookSource data', uploadData);
    // let savedFolderPath = uploadData.link;
    let processStatistics = {
      processTime: uploadData.processingTime,
      UserStatistics: uploadData.UserStatistics,
      BookStatistics: uploadData.BookStatistics,
      ...uploadData.TokenAccumulator
    };

    console.log('Statistics', processStatistics);
    // setParsedStory(savedFolderPath);

    await uploadFileToS3(thumbnailSignedUrl.current.signedUrl, thumbnail);

    // setStoryFileName(null);
    // setThumbnail(null);

    await moveAllFiles(userProfile.data.userId, activeStoryObj.data.uuid, formContent, values.content);

    let storyName = title;
    if (storyName === "") {
      storyName = storyFileName.name.split('.');
      storyName = storyName[0];
    }
    let cleanedTitle = storyName.replace(/[^a-z0-9]/gi, '').toLowerCase();

    contentSignedUrl.current.signedUrl = await fetchSignedUrlByType({
      requestType: 'ADMIN_PATH',
      userId: userProfile.data.userId,
      rootGroup: 'books',
      infoType: bookTypeName,
      folderName: 'content',
      fileName: `${cleanedTitle}.html`
    });

    await uploadHtmlToS3(contentSignedUrl.current.signedUrl, formContent.current);

    await submitForm(values, processStatistics);

    resetForm({
      values: initialValues
    });

    activeElapsedTime.current = 0;

    console.log('About to refreshFetch within onSubmit');

    dispatch(fetchUserAndBookStatistics(storySelectedObj.current.data.uuid)).unwrap();
    getFullBook(storySelectedObj.current.data.uuid);
    refreshFetch();
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, resetForm, isSubmitting, isValid, dirty }) => (
        <div style={{ marginBottom: "70px", maxWidth: "1024px" }}>
          <Form>
            <FieldChangeHandler initialValues={initialValues} storySelectedObj={storySelectedObj} bookListOptions={bookListOptions} />
            <UpdateFieldValue formData={formData} />

            <HeaderAndPage
              headerImage={storyImporter}
              headerText="Story Importer"
              subHeaderText="Import and decode story structure"
              isCircular={false}
              toolbarComponent={
                <>
                  <Message className="importerMessageBox">
                    <Message.Header>Story Importer</Message.Header>
                    <p>Select a previously added book for uploading and creating the character/emotion database elements.</p>

                    {/* Processing Status Hint */}
                    <ProcessingStatusHint
                      selectedStory={values.selectedStory}
                      title={values.title}
                      thumbnail={values.thumbnail}
                      pdfFile={values.pdfFile}
                      isProcessing={isSubmitting}
                    />
                    <Divider />
                    {/* CustomToolbar with integrated entry fields */}
                    <CustomToolbar
                      toolBarCallback={handleFileURlSelection}
                      disabled={false}
                      headerContext={true}
                      values={values}
                      isSubmitting={isSubmitting}
                      storySelectedObj={storySelectedObj}
                      getFullBook={getFullBook}
                    />

                  </Message>

                </>
              }
            >
              {AuthStdFooter()}

            </HeaderAndPage>
          </Form>
          <div style={{ marginTop: "-30px", width: "1024px", zIndex: "4000" }}>
            <PdfViewer />
          </div>
          <UtilityModal isOpen={modalOpen}
            handleModalClose={handleModalClose}
            handleCancel={handleModalCancel}
            handleOverwrite={() => handleClear(resetForm)}
            handleSave={handleModalSubmit} promptObj={{
              image: storyInjestion,
              modal_header: 'Warning - Unsaved Data',
              header_text: 'Complete Story Injestion, Editing, Overwrite or Save',
              description_text: <div>
                <p>You have unsaved data. This data will be lost if you choose Overwrite. If you Cancel, you can continue editing your existing changes. Or, you can save your changes and proceed with your new selection.</p>
                <p>Cancel, Clear, or Save Data?</p></div>,
              button_neg_text: 'Cancel',
              button_pos_text: "Clear Form",
              button_save_text: "Submit"
            }} />
          {/* Render the modal confirmation */}
        </div>
      )}
    </Formik>
  );
};

export default StoryEditor;
